<template>
  <div class="form-out-view">
    <!-- //添加修改工作经历 -->
    <UserTitle :title="title"></UserTitle>
    <a-form :form="form" @submit="handleSubmit" class="form-all">
      <b-row>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="公司名称">
            <a-input
              v-decorator="[
                'company',
                {
                  rules: [{ required: true, message: '请填写公司名称' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="离职时间">
            <a-date-picker
              style="width:100%"
              v-decorator="['leaveTime']"
              placeholder="请选择离职时间"
              v-model="endValue"
              :disabled-date="disabledEndDate"
            />
          </a-form-item>
        </b-col>

        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="所在部门">
            <a-input
              v-decorator="[
                'department',
                {
                  rules: [{ required: true, message: '请填写所在部门' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="企业性质">
            <!-- <a-input v-decorator="['property']" /> -->
            <a-select v-decorator="['property']">
              <a-select-option value="国有企业">国有企业</a-select-option>
              <a-select-option value="私营企业">私营企业</a-select-option>
              <a-select-option value="外资企业">外资企业</a-select-option>
              <a-select-option value="事业单位">事业单位</a-select-option>
              <a-select-option value="公务员">公务员</a-select-option>
            </a-select>
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="从事岗位">
            <a-input
              v-decorator="[
                'duty',
                {
                  rules: [{ required: true, message: '请填写从事岗位' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="所属行业">
            <a-tree-select
              v-decorator="['industry']"
              style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              tree-data-simple-mode
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="入职时间">
            <a-date-picker
              style="width:100%"
              placeholder="请填写入职时间"
              v-model="startValue"
              :disabled-date="disabledStartDate"
              v-decorator="[
                'enterTime',
                {
                  rules: [{ required: true, message: '请填写入职时间' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <!-- <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="财经公司分类">
            <a-input v-decorator="['companyCategory']" />
          </a-form-item>
        </b-col> -->
        <a-form-item label="工作内容" class="all-input">
          <a-textarea
            v-decorator="[
              'content',
              {
                rules: [{ required: true, message: '请填写工作内容' }]
              }
            ]"
            placeholder="请描述一下自己的工作内容"
            :rows="8"
            allowClear
            :maxLength="120"
          />
        </a-form-item>
        <a-form-item label="特别经历" class="all-input">
          <a-textarea
            v-decorator="['specialExperience']"
            placeholder="请描述一下自己的特别经历"
            :rows="8"
            allowClear
            :maxLength="120"
          />
        </a-form-item>
        <a-form-item class="form-footer">
          <a-button class="success-button usually-button" html-type="submit"
            >保存</a-button
          >
          <a-button class="disable-button usually-button" @click="goBack"
            >取消</a-button
          >
        </a-form-item>
      </b-row>
    </a-form>
  </div>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  data() {
    return {
      startValue: null,
      endValue: null,
      treeData: [],
      id: this.$route.query.id || 0,
      type: this.$route.query.type || "add",
      loading: false,
      title: "编辑工作经历",
      imageUrl: "",
      form: this.$form.createForm(this, {
        name: "workForm"
      })
    };
  },
  mounted() {
    this.getData();
    this.getIndustry();
  },
  methods: {
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    //获取行业数据
    async getIndustry() {
      try {
        const data = await Api.Global.getIndustry();
        if (data) {
          this.treeData = data.data;
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    login() {
      return publicChange.userLogin();
    },
    async getData() {
      const login = this.login();
      if (login) {
        if (this.type == "edit" && this.id !== 0) {
          this.title = "修改工作经历";
          const jobHistory = await Api.User.getJobHistoryDetail(this.id);
          if (jobHistory) {
            this.$nextTick(() => {
              this.form.setFieldsValue({
                company: jobHistory.company,
                department: jobHistory.department,
                duty: jobHistory.duty,
                property: jobHistory.property,
                industry: jobHistory.industry,
                collegeClass: jobHistory.collegeClass,
                companyCategory: jobHistory.companyCategory,
                content: jobHistory.content,
                specialExperience: jobHistory.specialExperience,
                enterTime: this.$moment(jobHistory.enterTime) || null,
                leaveTime: this.$moment(jobHistory.leaveTime) || null
              });
            });
          }
        } else if (this.type == "add") {
          this.title = "新增工作经历";
        } else {
          this.$message.error("获取页面错误，请重新进入页面");
          this.$router.push("/user/talent");
        }
      } else {
        this.$router.push({
          path: "/login",
          query: { redirect: location.href }
        });
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        let data = {
          ...values,
          enterTime: this.$moment(values.enterTime) || null,
          leaveTime: this.$moment(values.leaveTime) || null
        };
        if (!err) {
          if (this.type == "edit") {
            const education = await Api.User.editJobHistory(data, this.id);
            if (education) {
              this.$message.success("修改成功");
              this.$router.push("/user/talent");
            } else {
              this.$message.error("修改失败");
            }
          } else {
            const education = await Api.User.createJobHistory(data);
            if (education) {
              this.$message.success("添加成功");
              this.$router.push("/user/talent");
            } else {
              this.$message.error("添加失败");
            }
          }
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped></style>
